export default "__VITE_ASSET__Blxcreuh__"